import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SpecialDay = ({ day, meals }) => (
  <Accordion
    sx={{ backgroundColor: "rgba(0, 0, 0, 0.4)", margin: "10px auto" }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`${day}-header`}>
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {day}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>
      {meals.map((meal, index) => (
        <Typography
          key={index}
          variant="body1"
          sx={{ fontSize: "1.25em", fontWeight: 900 }}
        >
          <strong style={{ color: "#ffff00" }}>{meal.label}:</strong>{" "}
          {meal.text}
        </Typography>
      ))}
    </AccordionDetails>
  </Accordion>
);

const Specials = () => {
  const dailySpecials = [
    {
      day: "Week of November 25th 2024",
      meals: [
        { label: "Daily Soups", text: "Monday-Saturday Made In-House!" },
        { label: "Lunch Special", text: "Served while it lasts" },
      ],
    },
    {
      day: "Monday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        {
          label: "Lunch & Dinner",
          text: "Chicken Fajitas w/refried beans 10.95",
        },
        { label: "Soup or Sides", text: "Beef Barley" },
      ],
    },
    {
      day: "Tuesday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        {
          label: "Lunch & Dinner",
          text: "Hot Prime Sandwich w/Mashed Potatoes & Gravy 15.95",
        },
        { label: "Soup or Sides", text: "Tomato Bisque" },
      ],
    },
    {
      day: "Wednesday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        { label: "Lunch & Dinner", text: "Turkey Melt 9.95" },
        { label: "Soup or Sides", text: "Chicken Pot Pie" },
      ],
    },
    {
      day: "Thursday",
      meals: [
        { label: "Breakfast", text: "Happy Thanksgiving!" },
        { label: "Lunch & Dinner", text: "Happy Thanksgiving!" },
        { label: "Soup or Sides", text: "Happy Thanksgiving!" },
      ],
    },
    {
      day: "Friday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        {
          label: "Lunch",
          text: `Fish & Chips 9.95, Soup & Sandwich 8.50 / Prime Rib`,
        },
        {
          label: "Dinner",
          text: `8 oz - 23.95 or 12 oz - 28.95 (Best & Most Affordable In Town!) Price includes complete dinner sides!`,
        },

        { label: "Soup or Sides", text: "Clam Chowder" },
      ],
    },
    {
      day: "Saturday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        {
          label: "Lunch",
          text: `Chef's Choice / Prime Rib`,
        },
        {
          label: "Dinner",
          text: `8 oz - 23.95 or 12 oz - 28.95 (Best & Most Affordable In Town!) Price includes complete dinner sides!`,
        },
        { label: "Soup or Sides", text: "Chef's Choice" },
      ],
    },
    {
      day: "Sunday",
      meals: [
        { label: "Breakfast", text: "3-Meat Scramble 10.95" },
        { label: "*", text: "Restaurant Closes at 2 PM on Sunday only" },
        { label: "*", text: "No Substitutions on Specials!" },
      ],
    },
  ];

  return (
    <Box
      sx={{
        backgroundImage: "url('/images/motherlode/promo_bg_1_mt.jpg')",
        padding: "20px",
        color: "#fff",
        textShadow:
          "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        margin: "0 auto",
        maxWidth: "80%",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#ffff00",
          textShadow:
            "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
        }}
      >
        Daily <strong>Specials</strong>
      </Typography>
      {dailySpecials.map((special, index) => (
        <SpecialDay key={index} day={special.day} meals={special.meals} />
      ))}
    </Box>
  );
};

export default Specials;
